import { render, staticRenderFns } from "./marker.vue?vue&type=template&id=2fa0f2a2&lang=true&"
import script from "./marker.vue?vue&type=script&lang=js&"
export * from "./marker.vue?vue&type=script&lang=js&"
import style0 from "./marker.vue?vue&type=style&index=0&id=2fa0f2a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports